// extracted by mini-css-extract-plugin
export default {"LoaderWrapper":"Loader_LoaderWrapper__Josz9","Loader":"Loader_Loader__5tPVb","load6":"Loader_load6__Sj7I0","round":"Loader_round__fNQtT"};